import Navbar from '@/pages/home/components/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import FeatureSection from '@/pages/home/components/FeatureSection';
import TrustSection from '@/pages/home/components/TrustSection';
import ArticleTeaserSection from '@/pages/home/components/ArticleTeaserSection';
import CTASection from '@/pages/home/components/CTASection';
import Footer from '@/pages/home/components/Footer';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Superbuy Spreadsheet',
  url: 'https://superbuyspreadsheet.buzz',
  description: 'The ultimate tool for organizing cross-border shopping from China. Track products, compare prices, and manage your entire buying workflow.',
};

const webSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Superbuy Spreadsheet',
  url: 'https://superbuyspreadsheet.buzz',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://superbuyspreadsheet.buzz/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <main>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webSchema) }} />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <FeatureSection />
      <TrustSection />
      <ArticleTeaserSection />
      <CTASection />
      <Footer />
    </main>
  );
}